module.exports = __webpack_public_path__ + "static/media/mt5.4f09b4e8.4f09b4e8.svg";